export const REPORTS_ACTIONS = {
  VIEW: 'REPORTS_VIEW',
  GENERATE: 'REPORTS_GENERATE'
};